import { render, staticRenderFns } from "./PMReportWrapper.vue?vue&type=template&id=be101640&"
import script from "./PMReportWrapper.vue?vue&type=script&lang=ts&"
export * from "./PMReportWrapper.vue?vue&type=script&lang=ts&"
import style0 from "./PMReportWrapper.vue?vue&type=style&index=0&id=be101640&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports